import { HttpStatusCodes } from '@service-initiation/shared-clients-http';
import { logger } from '@service-initiation/shared-clients-osp-logger';

import { reserveWithGoogleClient } from './clients/reserveWithGoogleClient';

export type CreateReserveWithGoogleConversionRequest = {
  conversionPartnerId: string;
  rwgToken: string;
};

export const createReserveWithGoogleConversion = async (
  request: CreateReserveWithGoogleConversionRequest
) => {
  try {
    const response = await reserveWithGoogleClient.createConversion({
      conversion_partner_id: request.conversionPartnerId,
      rwg_token: request.rwgToken,
    });

    if (response.status !== HttpStatusCodes.OK) {
      throw new Error('Received invalid response status from server.');
    }
  } catch (err) {
    if (err instanceof Error) {
      err.message = 'Failed to create reserve with google conversion';
      logger.error(err, { data: { request } });
      throw err;
    }
  }
};
